// AUTO-GENERATED by create-environment.js — do not edit by hand.
// Source: environments/development.env.ts + environments/version.json

import { AppConfig } from '../src/common/config/app-config';
import { environment as source } from './development.env';

export const environment: AppConfig = {
  ...source,
  app: { ...source.app, version: '1.0.53', build: 4064, appId: 'app.sequal.development' },
};
